import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { BUFFER_PANE } from "../../utilities/constants";

const orderBuffers = function (map, cpmDrawingOrder) {
    const buffers = [];
    map.eachLayer(layer => {
        if (layer.options?.pane === BUFFER_PANE && layer.bringToFront) {
            buffers.push(layer);
        }
    });

    if (cpmDrawingOrder) {
        buffers.sort((a, b) => a.options.cpm - b.options.cpm);
    } else {
        buffers.sort((a, b) => a.options.order - b.options.order);
    }

    buffers.forEach(layer => layer.bringToFront());
}

export default function BufferOrdering({ cpmDrawingOrder }) {
    const map = useMap();

    useEffect(() => {
        let frame = null;

        const scheduleOrder = function () {
            if (frame !== null) {
                return;
            }

            frame = requestAnimationFrame(() => {
                frame = null;
                orderBuffers(map, cpmDrawingOrder);
            });
        }

        const onLayerAdd = function (e) {
            if (e.layer?.options?.pane === BUFFER_PANE) {
                scheduleOrder();
            }
        }

        map.on("layeradd", onLayerAdd);
        scheduleOrder();

        return () => {
            map.off("layeradd", onLayerAdd);
            if (frame !== null) {
                cancelAnimationFrame(frame);
            }
        }
    }, [map, cpmDrawingOrder]);

    return null;
}